export default {
  lang: 'en',
  app: {
    title: {
      webTitle: 'Photonpay Partner',
      footTitle: 'Photonpay Cross-border Collection'
    },
    label: {
      billingCardManagement: 'Billing Card Management',
      addBillingCard: 'Add Billing Card',
      bankAccountName: 'Bank Account Name',
      bindPhoneNumber: 'Bind Phone Number',
      IDCard: 'ID Card',
      bankCard: 'Bank Card',
      bankAccount: 'Bank Account',
      myReward: 'My Reward',
      invitationCode: 'Invitation Code',
      myClient: 'My Client',
      productDescription: 'Product Description',
      settlementCard: 'Settlement Card',
      activityRules: 'Activity Rules',
      currentPostion: 'Current Postion',
      bePartner: 'Become A Partner',
      partnerLevel: 'Partner Level',
      goodDawning: 'Good Dawning',
			goodMorning: 'Good Morning',
			goodForenoon: 'Good Forenoon',
			goodNoon: 'Good Noon',
			goodAfternoon: 'Good Afternoon',
			goodEvening: 'Good Evening',
			goodNight: 'Good Night',
      goodNight1: 'Good Night',
      accumulatedBonus: 'Accumulated bonus (yuan)',
      toBeDettledBonus: 'Pending bonus (yuan)',
      settlementBonus: 'Settlement bonus (yuan)',
      registeredMembers: 'Number of registered members',
      numberOfRegisteredMembers: 'Number of registered members',
      accumulatedCredits: 'Accumulated credits (yuan)',
      latestBillingDate: 'Latest billing date: ',
      rewardRecord: 'Reward record',
      rewardAmount: 'Reward Amount (yuan)',
      settlementRrecord: 'Settlement record',
      settlementDate: 'Settlement Date',
      settlementAmount: 'Settlement Amount (yuan)',
      cllectionName: 'Collection name',
      memberPhone: 'Member phone number',
      registerDate: 'Registration Date',
      recommendedRegistered: 'Number of registered members recommended (person)',
      registeredMember: 'Number of registered members (person)',
      distance: 'distance',
      stillNeedMember: 'Still account members {num} people',
      recommendCumulativeAccount: 'Recommended cumulative account flow',
      stillNeed: 'still needed',
      supportPlatform: 'Support Platform',
      registration: 'Registration',
      shutDown: 'Shut Down',
      savePicture: 'Save Picture',
      cancel: 'cancel',
      partnerGuidelines: 'Invitation Strategy',
      rewardRuleDescription: 'Reward Settlement Instructions',
      phoneNumber: 'Phone Number',
      verificationCode: 'Verification Code'
    },
    validator: {
      nonEmpty: 'Cannot be Empty',
      noPhone: 'Please enter phone number'
    },
    options: {
      // 是否入账
      credited: {
        0: 'Credited',
        1: 'Unaccounted'
      }
    },
    word: {
      submit: 'Submit',
      click: 'Click',
      confirm: 'Confirm',
      bind: 'Bind'
    },
    sentence: {
      billingCardManagement: 'Hello，you have bound a settlement card。',
      addBillingCard: 'In order to ensure that you receive the reward money normally，please fill in your usual bank card information，and make sure the information is correct。',
      bankAccountName: 'Please enter bank account name',
      bindPhoneNumber: 'Please enter the mobile phone number bound to the bank card',
      plsPhoneNumber: 'Please Enter Phone Number',
      plsVerificationCode: 'Please Enter Verification Code',
      IDCard: 'Please enter Identification Number',
      bankCard: 'Please enter bank account',
      bankAccount: 'Please enter the bank name，e.g. Agricultural Bank Of China',
      inviteFriend: 'Invite friends to join us',
      totalRecordNum: 'Total {num} records',
      getVerificationCode: 'Get Verification Code',
      reacquire: 's Re-acquire',
      statementOfSettlement: 'the reward of the current month will be settled before the 10th of the next month (holiday postponed)'
    }
  }
}
